import type React from "react";

function Sample(): React.ReactNode {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: initial biome migration
    <svg
      version="1.1"
      x="0px"
      y="0px"
      style={{ height: 83, opacity: 0.7, position: "absolute", bottom: -28, width: 83 }}
      width="200px"
      height="200px"
      viewBox="0 0 200 200"
      enableBackground="new 0 0 200 200"
    >
      <g>
        <g>
          <path
            id="XMLID_179_"
            fill="#FFFFFF"
            d="M126.383,187.453c-2.354-2.544-5.266-4.719-8.935-6.377V48.777l4.22-7.314
			c1.874-3.248-0.471-7.307-4.22-7.307l0,0h-2.565H88.582c-2.692,0-4.873,2.182-4.873,4.872v142.048
			c-3.667,1.658-6.825,3.833-9.179,6.377h-0.123c-1.749,0-3.167,1.417-3.167,3.167v2.699h58.311v-2.699
			C129.552,188.87,128.134,187.453,126.383,187.453z"
          />

          <path
            id="XMLID_178_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M126.016,187.453c-2.354-2.544-5.267-4.719-8.935-6.377V49.773c0-0.652,0.183-1.292,0.525-1.846l3.846-6.228
			c1.935-3.135-0.32-7.177-4.004-7.177l0,0h-2.565H88.046c-2.598,0-4.703,2.107-4.703,4.705v141.849
			c-3.669,1.658-6.459,4.175-8.814,6.744h-0.122c-1.943,0-3.533,1.59-3.533,3.532v2.334h58.31v-3.068
			C129.185,188.87,127.766,187.453,126.016,187.453z"
          />
          <path
            id="XMLID_177_"
            fill="#A4C8A6"
            d="M115.333,185.754l-3.019-1.366V80.364h-0.062c0-3.88-3.147-7.029-7.028-7.029
			c-3.186,0-5.875,2.123-6.736,5.029c-0.55-0.359-1.207-0.566-1.913-0.566c-1.611,0-2.968,1.087-3.38,2.566h-4.352v104.023
			l-3.018,1.366c-1.571,0.71-3.023,1.531-4.317,2.431h38.022C118.26,187.253,116.865,186.447,115.333,185.754z"
          />

          <path
            id="XMLID_176_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M115.333,185.754l-3.019-1.366V80.364h-0.062c0-3.88-3.147-7.029-7.028-7.029c-3.186,0-5.875,2.123-6.736,5.029
			c-0.55-0.359-1.207-0.566-1.913-0.566c-1.611,0-2.968,1.087-3.38,2.566h-4.352v104.023l-3.018,1.366
			c-1.571,0.71-3.023,1.531-4.317,2.431h38.022C118.26,187.253,116.865,186.447,115.333,185.754z"
          />
          <circle id="XMLID_175_" fill="#A4C8A6" cx="95.628" cy="58.544" r="3.484" />

          <circle
            id="XMLID_170_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="95.628"
            cy="58.544"
            r="3.484"
          />
          <circle id="XMLID_168_" fill="#A4C8A6" cx="99.296" cy="21.503" r="6.051" />

          <circle
            id="XMLID_166_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="99.296"
            cy="21.503"
            r="6.051"
          />
          <circle id="XMLID_164_" fill="#A4C8A6" cx="106.997" cy="8.668" r="2.355" />

          <circle
            id="XMLID_163_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="106.997"
            cy="8.668"
            r="2.355"
          />
          <circle id="XMLID_161_" fill="#A4C8A6" cx="105.896" cy="49.742" r="1.467" />

          <circle
            id="XMLID_157_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="105.896"
            cy="49.742"
            r="1.467"
          />
          <circle id="XMLID_155_" fill="#81B384" cx="101.243" cy="115.136" r="1.168" />
          <circle id="XMLID_154_" fill="#81B384" cx="99.325" cy="131.919" r="3.65" />
          <circle id="XMLID_152_" fill="#81B384" cx="104.092" cy="150.624" r="1.622" />
        </g>
        <g>
          <path
            id="XMLID_150_"
            fill="#FFFFFF"
            d="M66.473,121.933V66.795H46.669v55.137c-17.237,4.414-30.256,20.435-30.256,39.298
			c0,13.197,6.521,24.755,16.317,32.457h48.415c9.797-7.702,15.951-19.26,15.951-32.457
			C97.096,142.367,84.077,126.347,66.473,121.933z"
          />

          <path
            id="XMLID_146_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M66.473,121.933V66.795H46.669v55.137c-17.237,4.414-30.256,20.435-30.256,39.298c0,13.197,6.521,24.755,16.317,32.457h48.415
			c9.797-7.702,15.951-19.26,15.951-32.457C97.096,142.367,84.077,126.347,66.473,121.933z"
          />
          <path
            id="XMLID_141_"
            fill="#B6D3B8"
            d="M88.953,146.377h-9.781c-0.158-2.049-1.867-3.667-3.958-3.667
			c-2.09,0-3.801,1.618-3.959,3.667h-0.399c-0.191-3.676-3.225-6.602-6.95-6.602c-1.169,0-2.271,0.293-3.238,0.803
			c-1.336-3.812-4.962-6.547-9.23-6.547c-4.708,0-8.637,3.327-9.569,7.758c-0.889-0.574-1.946-0.912-3.082-0.912
			c-3.079,0-5.578,2.447-5.676,5.5h-8.187c-2.09,4.579-3.191,9.631-3.191,14.67c0,10.569,4.649,20.43,12.776,27.138h44.859
			c8.128-6.708,12.778-16.569,12.778-27.138C92.145,156.008,91.042,150.956,88.953,146.377z"
          />

          <path
            id="XMLID_138_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M88.953,146.377h-9.781c-0.158-2.049-1.867-3.667-3.958-3.667c-2.09,0-3.801,1.618-3.959,3.667h-0.399
			c-0.191-3.676-3.225-6.602-6.95-6.602c-1.169,0-2.271,0.293-3.238,0.803c-1.336-3.812-4.962-6.547-9.23-6.547
			c-4.708,0-8.637,3.327-9.569,7.758c-0.889-0.574-1.946-0.912-3.082-0.912c-3.079,0-5.578,2.447-5.676,5.5h-8.187
			c-2.09,4.579-3.191,9.631-3.191,14.67c0,10.569,4.649,20.43,12.776,27.138h44.859c8.128-6.708,12.778-16.569,12.778-27.138
			C92.145,156.008,91.042,150.956,88.953,146.377z"
          />

          <path
            id="XMLID_136_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M42.345,147.422c-0.445-1.117-0.689-2.335-0.689-3.611c0-5.401,4.379-9.781,9.78-9.781c4.269,0,7.897,2.735,9.233,6.549"
          />

          <path
            id="XMLID_135_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M68.403,152.066"
          />

          <path
            id="XMLID_133_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M57.479,144.047c1.055-2.51,3.535-4.271,6.427-4.271c3.849,0,6.969,3.12,6.969,6.969"
          />

          <path
            id="XMLID_132_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M71.24,146.684c0-2.193,1.78-3.974,3.974-3.974c2.193,0,3.971,1.78,3.971,3.974"
          />
          <rect id="XMLID_131_" x="49.786" y="52.493" fill="#C6DDC8" width="13.57" height="22.738" />

          <rect
            id="XMLID_130_"
            x="49.786"
            y="52.493"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            width="13.57"
            height="22.738"
          />
          <path
            id="XMLID_126_"
            fill="#E7F1E8"
            d="M67.757,66.429H45.751c-2.429,0-4.4-1.972-4.4-4.401l0,0c0-2.43,1.971-4.401,4.4-4.401
			h22.006c2.43,0,4.4,1.971,4.4,4.401l0,0C72.157,64.458,70.187,66.429,67.757,66.429z"
          />

          <path
            id="XMLID_124_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M67.757,66.429H45.751c-2.429,0-4.4-1.972-4.4-4.401l0,0c0-2.43,1.971-4.401,4.4-4.401h22.006c2.43,0,4.4,1.971,4.4,4.401l0,0
			C72.157,64.458,70.187,66.429,67.757,66.429z"
          />
          <circle id="XMLID_123_" fill="#B6D3B8" cx="62.347" cy="128.744" r="4.492" />
          <circle id="XMLID_121_" fill="#B6D3B8" cx="57.684" cy="90.708" r="2.031" />
          <circle id="XMLID_120_" fill="#B6D3B8" cx="53.808" cy="105.168" r="2.555" />

          <circle
            id="XMLID_118_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="62.347"
            cy="128.744"
            r="4.492"
          />

          <circle
            id="XMLID_105_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="57.684"
            cy="90.708"
            r="1.453"
          />

          <circle
            id="XMLID_103_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="53.808"
            cy="105.168"
            r="2.555"
          />
          <circle id="XMLID_102_" fill="#B6D3B8" cx="76.119" cy="134.143" r="1.111" />

          <circle
            id="XMLID_100_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="76.119"
            cy="134.143"
            r="1.111"
          />

          <circle
            id="XMLID_99_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="69.519"
            cy="137.443"
            r="0.29"
          />
          <circle id="XMLID_98_" fill="#81B384" cx="49.236" cy="170.215" r="1.1" />
          <circle id="XMLID_97_" fill="#81B384" cx="57.305" cy="179.017" r="2.338" />
          <circle id="XMLID_95_" fill="#81B384" cx="60.604" cy="166.182" r="1.101" />
          <circle id="XMLID_87_" fill="#81B384" cx="68.307" cy="177.917" r="1.238" />
        </g>
        <g>
          <path
            id="XMLID_86_"
            fill="#E7F1E8"
            d="M152.167,84.766H128.94c-2.43,0-4.399-1.971-4.399-4.402l0,0
			c0-2.43,1.97-4.401,4.399-4.401h23.227c2.429,0,4.399,1.971,4.399,4.401l0,0C156.566,82.795,154.596,84.766,152.167,84.766z"
          />

          <path
            id="XMLID_85_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M152.167,84.766H128.94c-2.43,0-4.399-1.971-4.399-4.402l0,0c0-2.43,1.97-4.401,4.399-4.401h23.227
			c2.429,0,4.399,1.971,4.399,4.401l0,0C156.566,82.795,154.596,84.766,152.167,84.766z"
          />
          <path
            id="XMLID_84_"
            fill="#FFFFFF"
            d="M150.454,131.709V84.766h-19.803v46.943l-32.136,50.336
			c-3.11,4.883,0.321,11.274,6.11,11.274h71.551c5.789,0,9.373-6.392,6.263-11.274L150.454,131.709z"
          />

          <path
            id="XMLID_82_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M150.454,131.709V84.766h-19.803v46.943l-32.136,50.336c-3.11,4.883,0.321,11.274,6.11,11.274h71.551
			c5.789,0,9.373-6.392,6.263-11.274L150.454,131.709z"
          />
          <path
            id="XMLID_81_"
            fill="#CADFCB"
            d="M178.105,184.785l-12.904-20.322c-1.358-3.209-4.298-5.434-7.705-5.434
			c-1.738,0-3.354,0.582-4.702,1.575c-1.533-1.652-3.625-2.675-5.931-2.675c-3.236,0-6.048,2.002-7.488,4.951h-1.547
			c-1.538-1.701-3.661-2.75-6.003-2.75c-2.343,0-4.465,1.049-6.004,2.75h-0.646c-1.188,0.7-2.546,1.1-3.986,1.1
			s-2.798-0.397-3.985-1.1h-0.385l-13.976,21.906c-0.688,1.083-0.288,1.995-0.149,2.249c0.236,0.43,0.801,1.148,1.93,1.148h71.55
			c1.209,0,1.78-0.799,1.967-1.14C178.438,186.504,178.672,185.675,178.105,184.785z"
          />

          <path
            id="XMLID_80_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            d="
			M178.105,184.785l-12.904-20.322c-1.358-3.209-4.298-5.434-7.705-5.434c-1.738,0-3.354,0.582-4.702,1.575
			c-1.533-1.652-3.625-2.675-5.931-2.675c-3.236,0-6.048,2.002-7.488,4.951h-1.547c-1.538-1.701-3.661-2.75-6.003-2.75
			c-2.343,0-4.465,1.049-6.004,2.75h-0.646c-1.188,0.7-2.546,1.1-3.986,1.1s-2.798-0.397-3.985-1.1h-0.385l-13.976,21.906
			c-0.688,1.083-0.288,1.995-0.149,2.249c0.236,0.43,0.801,1.148,1.93,1.148h71.55c1.209,0,1.78-0.799,1.967-1.14
			C178.438,186.504,178.672,185.675,178.105,184.785z"
          />
          <circle id="XMLID_79_" fill="#CADFCB" cx="136.781" cy="148.382" r="3.685" />

          <circle
            id="XMLID_77_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="136.781"
            cy="148.382"
            r="3.685"
          />
          <circle id="XMLID_75_" fill="#CADFCB" cx="149.452" cy="150.802" r="2.421" />

          <circle
            id="XMLID_73_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="149.452"
            cy="150.802"
            r="2.421"
          />
          <circle id="XMLID_72_" fill="#CADFCB" cx="141.745" cy="128.316" r="1.925" />

          <circle
            id="XMLID_70_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="141.745"
            cy="128.316"
            r="1.925"
          />
          <circle id="XMLID_69_" fill="#81B384" cx="135.419" cy="171.315" r="2.337" />
          <circle id="XMLID_68_" fill="#81B384" cx="150.752" cy="176.749" r="1.169" />

          <circle
            id="XMLID_67_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="143.511"
            cy="106.611"
            r="0.757"
          />

          <circle
            id="XMLID_66_"
            fill="none"
            stroke="#81B384"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            cx="137.645"
            cy="89.374"
            r="0.758"
          />
        </g>
      </g>
    </svg>
  );
}

export default Sample;
